module.exports = __webpack_public_path__ + "img/64554D_D1C9C1_ABADA0_0E0C0A-256px.1ced843d.png";